module.exports = __webpack_public_path__ + "resources/img/img_ahnlabv3_net_server_m_en.c0574b497251b10e87ab2f54f79fa5ab.png";